module.exports = __webpack_public_path__ + "img/school2.b195622f.png";